// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KMWW","placeholdersHeader":"styles_placeholdersHeader__2mTpT","editorStyle":"styles_editorStyle__wsDXc","placeholdersBox":"styles_placeholdersBox__1UYrz"};